import React, { createContext, useContext, ReactNode } from 'react';
import useGeneralState from 'utils/hooks/useGeneralState';

interface MobileNavigationContextProps {
  showSection: number;
  setShowSection: (
    newState: number,
    operation?: 'Update' | 'Push' | 'Pop' | 'Delete',
    customOnBack?: ((currentState: number) => number) | undefined,
  ) => void;
}

const MobileNavigationContext = createContext<
  MobileNavigationContextProps | undefined
>(undefined);

export const MobileNavigationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { state: showSection, setState: setShowSection } = useGeneralState({
    id: 'MobileNavigation',
    initialState: 0,
  });

  return (
    <MobileNavigationContext.Provider value={{ showSection, setShowSection }}>
      {children}
    </MobileNavigationContext.Provider>
  );
};

export const useMobileNavigation = (): MobileNavigationContextProps => {
  const context = useContext(MobileNavigationContext);
  if (!context) {
    throw new Error(
      'useMobileNavigation must be used within a MobileNavigationProvider',
    );
  }
  return context;
};
